import Enumerator from '../global/Enumerator';

export const contactCompanyTrustStructures = [
  'none',
  'discretionary_trust',
  'bare_or_holding_trust',
  'smsf_trust',
  'property_trust',
  'unit_trust'
];

export class ContactCompanyTrustStructure extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'discretionary_trust';
        break;
      case '2':
        correctOption = 'bare_or_holding_trust';
        break;
      case '3':
        correctOption = 'smsf_trust';
        break;
      case '4':
        correctOption = 'property_trust';
        break;
      case '5':
        correctOption = 'unit_trust';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactCompanyTrustStructure.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  discretionary_trust: {
    get title() {
      return 'Discretionary trust';
    }
  },
  bare_or_holding_trust: {
    get title() {
      return 'Bare/holding trust';
    }
  },
  smsf_trust: {
    get title() {
      return 'SMSF trust';
    }
  },
  property_trust: {
    get title() {
      return 'Property trust';
    }
  },
  unit_trust: {
    get title() {
      return 'Unit trust';
    }
  }
});

export default {
  contactCompanyTrustStructures,
  ContactCompanyTrustStructure
};
